import { Component, AfterViewInit, ViewChild, NgZone, OnInit, ElementRef, HostListener } from '@angular/core';
import { MapLatLng } from '../models/map.latlng';
import { MapBounds } from '../models/map.bounds';
import { GMapMarker } from './gmap.marker';
import { MapMarker } from '../models/map.marker';
import { MapBaseDirective } from '../base/map.base';
import { MapCluster } from '../models/map.cluster';
import { GMapCluster } from './gmap.cluster';
import { MapPolyline } from '../models/map.polyline';
import { GPolyline } from './gmap.polyline';
import { MapPolylinePoint } from '../models/map.polylinePoint';
import { GCircle } from './gmap.circle';
import { MapCircle } from '../models/map.circle';
import { GPolygon } from './gmap.polygon';
import { MapPolygon } from '../models/map.polygon';
import { MapPolygonPoint } from '../models/map.polygonPoint';
import { MapService } from '../map.service';
import { HeatMap } from '../models/map.heatMap';
import { GMapHeatMap } from './gmap.heatMap';
import { MapPoint } from '../models/map.point';
import { GMapItinerary } from './gmap.itinerary';
import { HttpClient } from '@angular/common/http';
import { KmlToGeoJson } from '../utils/kml-to-geojson';
import { MapPlace } from '../models/map.place';

@Component({
  selector: 'lib-gmap-movisat',
  templateUrl: './gmap.component.html',
  styleUrls: ['./gmap.component.css']
})
export class GMapComponent extends MapBaseDirective implements OnInit, AfterViewInit {
  @ViewChild('search', { static: false }) searchElementRef: any;
  public infoWindowMarker: any = null;
  private infoWindowPolyline: any = null;
  private infoWindowCircle: any = null;
  private markerSearch: any = null;
  private infoWindowSearch: any = null;
  public selectedMarker?: GMapMarker;
  private myPosMarker: any = null;
  public static scritpCreate = false;
  private zoomEncuadreActivo = false;
  private polygonZoom: any = null;
  private posIniZoom: any = null;
  private lastPos: any = null;
  private maxZoom = 22;

  public constructor(
    private ngZone: NgZone,
    private mapService: MapService,
    private parentRef: ElementRef,
    private http: HttpClient
  ) {
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // Creo el script de carga para poder poner la ApiKey
    if (!GMapComponent.scritpCreate) {
      GMapComponent.scritpCreate = true;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=' + this.mapService.config?.googleApiKey + '&' +
        'libraries=marker,places,drawing,geometry,visualization&language=' + this.lang + "&callback=initMap&loading=async";
      document.body.appendChild(script);
      // Este método se llama cuando el mapa se ha cargado
      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.innerHTML = `function initMap() {
          var event = new CustomEvent("initMap.success");
          window.dispatchEvent(event);
      }`;
      document.body.appendChild(script2);
    } else {
      this.onInitMap();
    }
  }

  @HostListener('window:initMap.success', ['$event'])
  handleKeyDown(event: any) {
    this.onInitMap();
  }

  actualizarCursor(mapElement: HTMLElement, activar: boolean): void {
    mapElement.style.cursor = activar ? "crosshair" : "default";

    const innerDivs = mapElement.querySelectorAll("div");
    innerDivs.forEach(div => {
      (div as HTMLElement).style.cursor = activar ? "crosshair" : "default";
    });
  }

  onInitMap() {
    // Creo el div para el mapa y lo añado al div padre
    const mapDiv = document.createElement('div');
    mapDiv.id = 'movisat-map' + Date.now();
    mapDiv.style.position = 'relative';
    mapDiv.style.width = "100%";
    mapDiv.style.height = "100%";
    this.parentRef.nativeElement.appendChild(mapDiv);

    this.map = new google.maps.Map(mapDiv, {
      mapId: this.mapService.config?.mapId
    } as google.maps.MapOptions);

    const toolsDiv = document.createElement('div');
    toolsDiv.id = 'zoom-encuadre';
    toolsDiv.style.width = "80px";
    toolsDiv.style.height = "100px";
    toolsDiv.style.position = 'relative';
    toolsDiv.style.display = 'flex';
    toolsDiv.style.zIndex = '99';
    toolsDiv.style.float = 'right';
    toolsDiv.style.marginTop = '168px';
    toolsDiv.style.right = '10px';

    // Creo el div para el botón del zoom de encuadre
    const zoomEncuadre = document.createElement('div');
    zoomEncuadre.id = 'zoom-encuadre';
    zoomEncuadre.style.width = "40px";
    zoomEncuadre.style.height = "40px";
    zoomEncuadre.style.position = 'relative';
    zoomEncuadre.style.display = 'flex';
    zoomEncuadre.style.zIndex = '99';
    zoomEncuadre.style.backgroundImage = 'url("../../../assets/images/zoom-encuadre.png")';
    zoomEncuadre.style.backgroundSize = '24px 24px';
    zoomEncuadre.style.backgroundPosition = '8px 8px';
    zoomEncuadre.style.backgroundRepeat = 'no-repeat';
    zoomEncuadre.style.backgroundColor = 'white';
    zoomEncuadre.style.border = 'none';
    zoomEncuadre.style.outline = 'none';
    zoomEncuadre.style.borderRadius = '4px';
    zoomEncuadre.style.boxShadow = '0 1px 4px rgba(0, 0, 0, 0.6)';
    zoomEncuadre.style.cursor = 'pointer';
    zoomEncuadre.style.float = 'right';
    zoomEncuadre.style.marginTop = '0px';
    zoomEncuadre.style.right = '-40px';
    zoomEncuadre.title = this.translate('Zoom_encuadre', 'Zoom de encuadre');
    const mapContainer = document.querySelector("[id^='movisat-map']") as HTMLElement | null;
    zoomEncuadre.addEventListener("click", () => {
      this.zoomEncuadreActivo = !this.zoomEncuadreActivo;

      zoomEncuadre.style.backgroundColor = this.zoomEncuadreActivo ? "#a3a3a3" : "white";
      zoomEncuadre.style.backgroundImage = this.zoomEncuadreActivo
        ? 'url("../../../assets/images/zoom-encuadre1.png")'
        : 'url("../../../assets/images/zoom-encuadre.png")';

      if (mapContainer) {
        this.actualizarCursor(mapContainer, this.zoomEncuadreActivo);
      }
    });


    if (mapContainer) {
      mapContainer.addEventListener("mousemove", () => {
        if (this.zoomEncuadreActivo) {
          this.actualizarCursor(mapContainer, this.zoomEncuadreActivo);
        }
      });
    }

    // Eventos para el hover del botón
    zoomEncuadre.addEventListener("mouseover", () => {
      if (!this.zoomEncuadreActivo) {
        zoomEncuadre.style.backgroundImage = 'url("../../../assets/images/zoom-encuadre0.png")';
      }
    });

    zoomEncuadre.addEventListener("mouseout", () => {
      if (!this.zoomEncuadreActivo) {
        zoomEncuadre.style.backgroundImage = 'url("../../../assets/images/zoom-encuadre.png")';
      }
    });
    // Creo el div para el botón de mi localización
    const myPosDiv = document.createElement('div');
    myPosDiv.id = 'my-location';
    myPosDiv.style.width = "40px";
    myPosDiv.style.height = "40px";
    myPosDiv.style.position = 'relative';
    myPosDiv.style.display = 'flex';
    myPosDiv.style.zIndex = '99';
    myPosDiv.style.backgroundImage = 'url("../../../assets/images/mylocation.png")';
    myPosDiv.style.backgroundSize = '24px 24px';
    myPosDiv.style.backgroundPosition = '8px 8px';
    myPosDiv.style.backgroundRepeat = 'no-repeat';
    myPosDiv.style.backgroundColor = 'white';
    myPosDiv.style.border = 'none';
    myPosDiv.style.outline = 'none';
    myPosDiv.style.borderRadius = '4px';
    myPosDiv.style.boxShadow = '0 1px 4px rgba(0, 0, 0, 0.6)';
    myPosDiv.style.cursor = 'pointer';
    myPosDiv.style.float = 'right';
    myPosDiv.style.marginTop = '58px';
    myPosDiv.style.right = '0px';
    myPosDiv.title = this.translate('Mi_posicion', 'Mi posición');
    myPosDiv.addEventListener("click", (e) => {
      this.onMyLocation();
    });
    myPosDiv.addEventListener("mouseover", () => {
      myPosDiv.style.backgroundImage = 'url("../../../assets/images/mylocation0.png")';
    });
    myPosDiv.addEventListener("mouseout", () => {
      myPosDiv.style.backgroundImage = 'url("../../../assets/images/mylocation.png")';
    });
    // Añado el div con los botones al mapa
    toolsDiv.appendChild(zoomEncuadre);
    toolsDiv.appendChild(myPosDiv);
    mapDiv.appendChild(toolsDiv);
    // Configuro las opciones del mapa

    // Ahora los estilos del mapa se controlan desde la consola de Google Maps
    this.map.setOptions({
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false,
      draggableCursor: 'default',
      zoomControlOptions: {
        style: 1, //google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      styles: [ // Oculto los puntos de interes
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        }
      ]
    });

    // Preparo la búsqueda de direcciones en el mapa
    this.geoCoder = new google.maps.Geocoder();
    let options: any = {};
    const sb = this.searchBounds.split(',');
    if (sb.length === 4) {
      // Restrinjo el área de busqueda preferido
      const sw = new google.maps.LatLng(Number.parseFloat(sb[0]), Number.parseFloat(sb[1]));
      const ne = new google.maps.LatLng(Number.parseFloat(sb[2]), Number.parseFloat(sb[3]));
      options = {
        location: new google.maps.LatLng(sw.lat() + (ne.lat() - sw.lat()) / 2, sw.lng() + (ne.lng() - sw.lng()) / 2),
        bounds: new google.maps.LatLngBounds(sw, ne),
        types: ['geocode']
      }
    } else {
      options = {
        types: ['geocode']
      }
    }
    // Añado la restricción por pais si se ha especificado
    if (this.searchCountry.length >= 2) {
      options.componentRestrictions = {
        country: this.searchCountry
      }
    }
    if (!this.noSearch) {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, options);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place0: any = autocomplete.getPlace();
          if (place0.geometry !== undefined && place0.geometry !== null) {
            const lat = place0.geometry.location.lat();
            const lng = place0.geometry.location.lng();
            this.setCenter(new MapLatLng(lat, lng));
            this.searchElementRef.nativeElement.value = '';
            setTimeout(() => {
              this.searchElementRef.nativeElement.focus()
            }, 500);
            const title = place0.formatted_address;
            if (this.markerSearch) {
              this.markerSearch.setMap(null);
            }
            if (this.infoWindowSearch) {
              this.infoWindowSearch.setMap(null);
            }
            if (place0.formatted_address) {
              this.markerSearch = new google.maps.Marker({
                position: new MapLatLng(lat, lng),
                draggable: false,
                clickable: true,
                icon: '',
                title: title,
                visible: true,
                zIndex: 999
              });
              this.markerSearch.setMap(this.map);
              this.infoWindowSearch = new google.maps.InfoWindow({
                content: place0.formatted_address
              });
              this.infoWindowSearch.setZIndex(999);
              this.infoWindowSearch.open(this.map, this.markerSearch);
              google.maps.event.addListener(this.markerSearch, 'click', () => {
                this.infoWindowSearch.open(this.map, this.markerSearch);
              });
              google.maps.event.addListener(this.infoWindowSearch, 'closeclick', () => {
                this.markerSearch.setMap(null);
                this.infoWindowSearch.setMap(null);
              });
            }
            const place = new MapPlace();
            place.Label = place0.formatted_address;
            if (place0.address_components) {
              place0.address_components.forEach((elem: any) => {
                if (elem.types.includes('street_number')) {
                  place.StreetNumber = elem.long_name;
                } else {
                  if (elem.types.includes('route')) {
                    place.Street = elem.long_name;
                  } else {
                    if (elem.types.includes('locality')) {
                      place.Locality = elem.long_name;
                    } else {
                      if (elem.types.includes('administrative_area_level_2')) {
                        place.AdministrativeArea2 = elem.long_name;
                      } else {
                        if (elem.types.includes('administrative_area_level_1')) {
                          place.AdministrativeArea1 = elem.long_name;
                        } else {
                          if (elem.types.includes('country')) {
                            place.Country = elem.long_name;
                          } else {
                            if (elem.types.includes('postal_code')) {
                              place.PostalCode = elem.long_name;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              });
            }
            this.onMapSearch(new MapLatLng(lat, lng), place);
          }
        });
      });
    }
    this.onMapReady(this);
    this.map.addListener("click", (e: any) => {
      this.onMapClick(e.latLng);
    });
    this.map.addListener("zoom_changed", () => {
      this.onZoomChange(this.map.getZoom());
    });
    this.map.addListener("bounds_changed", () => {
      this.onBoundsChange(this.map.getBounds());
    });
    this.map.addListener("mousemove", (e: any) => {
      this.onMapMouseMove(e.latLng);
    });
    this.map.addListener("dragstart", (e: any) => {
      if (!this.zoomEncuadreActivo) return;
      this.posIniZoom = this.lastPos;
    });
    this.map.addListener("drag", (e: any) => {
      if (this.zoomEncuadreActivo) {
        this.map.setCenter(this.map.getCenter());
        if (this.polygonZoom) {
          this.polygonZoom.setMap(null);
        }
        this.polygonZoom = new google.maps.Polygon({
          strokeColor: 'black',
          strokeOpacity: 0.3,
          strokeWeight: 1,
          fillColor: 'gray',
          fillOpacity: 0.3,
          geodesic: true
        });
        this.polygonZoom.setMap(this.map);
        const dLat = this.lastPos.lat() - this.posIniZoom.lat();
        const dLng = this.lastPos.lng() - this.posIniZoom.lng();
        this.polygonZoom.getPath().push(this.posIniZoom);
        this.polygonZoom.getPath().push(new google.maps.LatLng(this.posIniZoom.lat() + dLat, this.posIniZoom.lng()));
        this.polygonZoom.getPath().push(new google.maps.LatLng(this.posIniZoom.lat() + dLat, this.posIniZoom.lng() + dLng));
        this.polygonZoom.getPath().push(new google.maps.LatLng(this.posIniZoom.lat(), this.posIniZoom.lng() + dLng));
      }
    });
    this.map.addListener("dragend", (e: any) => {
      if (this.zoomEncuadreActivo) {
        let lat1, lat2, lng1, lng2;
        if (this.polygonZoom) {
          this.polygonZoom.setMap(null);
        }
        if (this.posIniZoom.lat() < this.lastPos.lat()) {
          lat1 = this.posIniZoom.lat();
          lat2 = this.lastPos.lat();
        } else {
          lat1 = this.lastPos.lat();
          lat2 = this.posIniZoom.lat();
        }
        if (this.posIniZoom.lng() < this.lastPos.lng()) {
          lng1 = this.posIniZoom.lng();
          lng2 = this.lastPos.lng();
        } else {
          lng1 = this.lastPos.lng();
          lng2 = this.posIniZoom.lng();
        }
        this.map.fitBounds(
          new google.maps.LatLngBounds(new google.maps.LatLng(lat1, lng1), new google.maps.LatLng(lat2, lng2)));
      }
    });
    // Para cuando se mueve el puntero sobre el mapa y se está arrastrando (zoom de encuadre)
    mapDiv.addEventListener('mousemove', (e: MouseEvent) => {
      if (!this.zoomEncuadreActivo) return;
      const rect = mapDiv.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const pos = this.screenPointToLatLng(new MapPoint(x, y));
      this.lastPos = new google.maps.LatLng(pos.lat, pos.lng);
    });
  }

  onMyLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.map.setCenter(pos);
        if (this.zoom < 16) {
          this.setZoom(16);
        }
        if (this.myPosMarker) {
          this.myPosMarker.setMap(null);
        }
        this.myPosMarker = new google.maps.Marker({
          title: pos.lat() + ', ' + pos.lng(),
          position: pos,
          icon: {
            url: "assets/images/pos.png",
            size: new google.maps.Size(32, 32),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 16)
          },
          zIndex: 999
        });
        this.myPosMarker.setMap(this.map);
      });
    }
  }

  override setMapType(type: string) {
    this.mapType = type;
  }

  // Redimensiona el mapa para que se adapte al tamaño del div que lo contiene
  override resize() {
    google.maps.event.trigger(this.map, "resize");
  }

  override onMapClick($event: any) {
    super.onMapClick(new MapLatLng($event.lat(), $event.lng()));
  }

  override onMapMouseMove($event: any) {
    super.onMapMouseMove(new MapLatLng($event.lat(), $event.lng()));
  }

  override onMapSearch(position: MapLatLng, place: any) {
    super.onMapSearch(position, place);
  }

  override onBoundsChange(mapBound: any) {
    // Recupero las equinas del mapa
    super.onBoundsChange(new MapBounds(new MapLatLng(mapBound.getSouthWest().lat(), mapBound.getSouthWest().lng()),
      new MapLatLng(mapBound.getNorthEast().lat(), mapBound.getNorthEast().lng())));
  }

  override addMarker(id: number, title: string, label: string, content: string, position: MapLatLng, icon: string, zIndex: number,
    drag: boolean, visible: boolean, minZoom: number, maxZoom: number, cluster: boolean, clusterV2: any): MapMarker {
    return new GMapMarker(id, title, label, content, position, icon, zIndex,
      this.map, drag, visible, this, clusterV2);
  }

  // Elimina un marcador
  override removeMarker(marker: MapMarker) {
    if (marker instanceof GMapMarker) {
      marker.remove();
    }
  }

  // Crea un cluster de marcadores
  override addCluster(id: number, maxZoom: number): MapCluster {
    const cluster = new GMapCluster(id, maxZoom, this, this.map);
    return cluster;
  }

  // Borra todos los marcadores del cluster
  override removeCluster(cluster: MapCluster) {
    cluster.removeMarkers();
  }

  // Devuelve las coordenadas de las esquinas del mapa
  override getBounds(): MapBounds {
    const bounds = this.map.getBounds();
    const sw = new MapLatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
    const ne = new MapLatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
    return new MapBounds(sw, ne);
  }

  // Permite hacer un zoom de encuadre
  override fitTo(mapBounds: MapBounds) {
    this.map.fitBounds(
      new google.maps.LatLngBounds(
        new google.maps.LatLng(mapBounds.swCorner.lat, mapBounds.swCorner.lng),
        new google.maps.LatLng(mapBounds.neCorner.lat, mapBounds.neCorner.lng)
      ));
  }

  // Permite centrar el mapa en un punto con animación
  override panTo(point: MapLatLng) {
    this.map.panTo(new google.maps.LatLng(point.lat, point.lng));
  }

  // Crea una polilinea
  override addPolyline(id: number, color: string, weight: number, opacity: number, clickable: boolean): MapPolyline {
    const polyline = new GPolyline(id, this.map, color, opacity, weight, clickable, this);
    google.maps.event.addListener(polyline.polyline, 'click', (event: any) => {
      if (this.infoWindowPolyline !== null) {
        this.infoWindowPolyline.close();
      }
      const point = polyline.getNearbyPoint(event.latLng);
      if (point !== null) {
        if (point.content && point.content.length > 0) {
          this.infoWindowPolyline = new google.maps.InfoWindow({
            content: point.content
          });
          this.infoWindowPolyline.setZIndex(999);
          this.infoWindowPolyline.setPosition(new google.maps.LatLng(point.point.lat, point.point.lng));
          this.infoWindowPolyline.open(this.map);
        }
        point.clickPoint = new MapLatLng(event.latLng.lat(), event.latLng.lng());
        this.onPolylineClick(point);
      }
    });
    return polyline;
  }

  // Añade un punto a una polilinea
  override addPolylinePoint(id: number, polyline: MapPolyline, content: string, position: MapLatLng): MapPolylinePoint {
    const point = polyline.addPoint(id, content, position);
    point.polyline = polyline;
    return point;
  }

  // Borra una polilinea
  override removePolyline(polyline: MapPolyline) {
    if (this.infoWindowPolyline) {
      this.infoWindowPolyline.close();
      this.infoWindowPolyline = null;
    }
    if (polyline instanceof MapPolyline) {
      polyline.remove();
    }
  }

  // Crea un polígono
  override addPolygon(id: number, strokeColor: string, weight: number, strokeOpacity: number, fillColor: string, fillOpacity: number,
    editable: boolean, hole: boolean, content: string): MapPolygon {
    const polygon = new GPolygon(id, this.map, strokeColor, strokeOpacity, weight, fillColor, fillOpacity, editable, hole, this, content);
    google.maps.event.addListener(polygon.polygon, 'click', (event: any) => {
      const point = polygon.getNearbyPoint(event.latLng);
      if (point !== null) {
        if (point.content && point.content.length > 0) {
          if (this.getBounds().contains(new MapLatLng(point.point.lat, point.point.lng))) {
            if (this.infoWindowPolyline !== null) {
              this.infoWindowPolyline.close();
            }
            this.infoWindowPolyline = new google.maps.InfoWindow({
              content: point.content
            });
            this.infoWindowPolyline.setZIndex(999);
            this.infoWindowPolyline.setPosition(new google.maps.LatLng(point.point.lat, point.point.lng));
            this.infoWindowPolyline.open(this.map);
          }
        }
        point.clickPoint = new MapLatLng(event.latLng.lat(), event.latLng.lng());
        point.polygon = polygon;
        this.onPolygonClick(point);
        this.onMapClick(event.latLng);
      }
    });
    google.maps.event.addListener(polygon.polygon, 'mousemove', (event: any) => {
      this.onMapMouseMove(event.latLng);
    });
    return polygon;
  }

  // Añade un punto a un polígono
  override addPolygonPoint(id: number, polygon: MapPolygon, content: string, position: MapLatLng, dataModel: any): MapPolygonPoint {
    const point = polygon.addPoint(id, content, position, dataModel);
    point.polygon = polygon;
    return point;
  }

  // Borra un polígono
  override removePolygon(polygon: MapPolygon) {
    if (this.infoWindowPolyline) {
      this.infoWindowPolyline.close();
      this.infoWindowPolyline = null;
    }
    if (polygon instanceof MapPolygon) {
      polygon.remove();
    }
  }

  // Añade un círculo
  override addCircle(id: number, content: string, strokeColor: string, strokeOpacity: number,
    strokeWeight: number, fillColor: string, fillOpacity: number, point: MapLatLng,
    radius: number, editable: boolean, draggable: boolean) {
    const circle = new GCircle(id, this.map, content, strokeColor, strokeOpacity,
      strokeWeight, fillColor, fillOpacity, point, radius, editable, draggable);
    google.maps.event.addListener(circle.circle, 'click', (event: any) => {
      if (this.infoWindowCircle !== null) {
        this.infoWindowCircle.close();
      }
      if (circle.content.length > 0) {
        if (this.infoWindowCircle !== null) {
          this.infoWindowCircle.close();
        }
        this.infoWindowCircle = new google.maps.InfoWindow({
          content: circle.content
        });
        this.infoWindowCircle.setZIndex(999);
        this.infoWindowCircle.setPosition(circle.circle.getCenter());
        this.infoWindowCircle.open(this.map);
      }
      circle.clickPoint = new MapLatLng(event.latLng.lat(), event.latLng.lng());
      this.onCircleClick(circle);
      this.onMapClick(event.latLng);
    });
    if (draggable) {
      google.maps.event.addListener(circle.circle, 'dragend', () => {
        const center = circle.circle.getCenter();
        this.center.lat = center.lat();
        this.center.lng = center.lng();
        circle.setCenter(new MapLatLng(center.lat(), center.lng()));
        if (this.infoWindowCircle) {
          this.infoWindowCircle.setPosition(new MapLatLng(center.lat(), center.lng()));
        }
        this.onCircleDragEnd(circle);
      });
    }
    if (editable) {
      google.maps.event.addListener(circle.circle, 'center_changed', () => {
        const center = circle.circle.getCenter();
        this.center.lat = center.lat();
        this.center.lng = center.lng();
        circle.center = new MapLatLng(center.lat(), center.lng());
        this.onCircleDragEnd(circle);
      });
      google.maps.event.addListener(circle.circle, 'radius_changed', () => {
        circle.radius = circle.circle.getRadius();
        this.onCircleRadiusChanged(circle);
      });
    }
    return circle;
  }

  // Borra un círculo
  override removeCircle(circle: MapCircle) {
    if (this.infoWindowCircle) {
      this.infoWindowCircle.close();
      this.infoWindowCircle = null;
    }
    if (circle instanceof MapCircle) {
      circle.remove();
    }
  }

  // Carga un archivo GeoJson
  override loadGeoJson(file: string, options: any = null) {
    return this.addGeoJson(this.map.data.loadGeoJson(file), options);
  }

  // Carga un archivo GeoJson
  override addGeoJson(file: any, options: any = null): any {
    const result = this.map.data.addGeoJson(file);
    this.map.data.setStyle((feature: any) => {
      let strokeColor = (options && options.strokeColor) ? options.strokeColor :
        (feature.getProperty('stroke') ? feature.getProperty('stroke') : '#0415fd');
      let strokeOpacity = (options && options.strokeOpacity) ? options.strokeOpacity :
        (feature.getProperty('stroke-opacity') ? feature.getProperty('stroke-opacity') : 0.8);
      let strokeWeight = (options && options.strokeWeight) ? options.strokeWeight :
        (feature.getProperty('stroke-width') ? feature.getProperty('stroke-width') : 1);
      let fillColor = (options && options.fillColor) ? options.fillColor :
        (feature.getProperty('fill') ? feature.getProperty('fill') : '#58dbf5');
      let fillOpacity = (options && options.fillOpacity) ? options.fillOpacity :
        (feature.getProperty('fill-opacity') ? feature.getProperty('fill-opacity') : 0.3);
      if (feature.getGeometry().getType() === 'Point' || feature.getGeometry().getType() === 'MultiPoint') {
        return {
          icon: 'assets/images/redmarker.png'
        }
      } else {
        if (feature.getGeometry().getType() === 'LineString' || feature.getGeometry().getType() === 'MultiLineString') {
          return {
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight,
          }
        } else {
          if (feature.getGeometry().getType() === 'Polygon' || feature.getGeometry().getType() === 'MultiPolygon') {
            return {
              strokeColor: strokeColor,
              strokeOpacity: strokeOpacity,
              strokeWeight: strokeWeight,
              fillColor: fillColor,
              fillOpacity: fillOpacity
            }
          } else {
            return undefined;
          }
        }
      }
    });
    this.map.data.addListener("click", (event: any) => {
      if (event.feature.getGeometry().getType() === 'Point' || event.feature.getGeometry().getType() === 'MultiPoint') {
        const geometry = event.feature.getGeometry();
        const res = new GMapMarker(0, '', '', '', new MapLatLng(geometry.get().lat(), geometry.get().lng()),
          '', 0, this.map, false, false, this, undefined);
        res.dataModel = options ? options.dataModel : undefined;
        if (options && options.content) {
          if (this.infoWindowMarker !== null) {
            this.infoWindowMarker.close();
          }
          this.infoWindowMarker = new google.maps.InfoWindow({
            content: options.content
          });
          this.infoWindowMarker.setZIndex(999);
          this.infoWindowMarker.setPosition(res.position);
          this.infoWindowMarker.open(this.map);
        }
        this.onMarkerClickGeoJson(res);
      } else {
        if (event.feature.getGeometry().getType() === 'LineString' ||
          event.feature.getGeometry().getType() === 'MultiLineString') {
          const points = event.feature.getGeometry();
          const pointsArray: any = [];
          points.forEachLatLng((pos: any) => {
            pointsArray.push(pos.lat());
            pointsArray.push(pos.lng());
            pointsArray.push(0);
          });
          // Calculo la posición donde se ha pinchado y obtengo el punto más cercano
          const point = new MapLatLng(event.latLng.lat(), event.latLng.lng());
          const index = this.getNearbyPoint(point, pointsArray);
          const res = new MapPolylinePoint(0, '', new MapLatLng(pointsArray[index], pointsArray[index + 1]));
          res.dataModel = options ? options.dataModel : undefined;
          if (options && options.content) {
            if (this.infoWindowPolyline !== null) {
              this.infoWindowPolyline.close();
            }
            this.infoWindowPolyline = new google.maps.InfoWindow({
              content: options.content
            });
            this.infoWindowPolyline.setZIndex(999);
            this.infoWindowPolyline.setPosition(res.point);
            this.infoWindowPolyline.open(this.map);
          }
          res.clickPoint = point;
          this.onPolylineClick(res);
        } else {
          if (event.feature.getGeometry().getType() === 'Polygon' ||
            event.feature.getGeometry().getType() === 'MultiPolygon') {
            const points = event.feature.getGeometry();
            const pointsArray: any = [];
            points.forEachLatLng((pos: any) => {
              pointsArray.push(pos.lat());
              pointsArray.push(pos.lng());
              pointsArray.push(0);
            });
            // Calculo la posición donde se ha pinchado y obtengo el punto más cercano
            const point = new MapLatLng(event.latLng.lat(), event.latLng.lng());
            const index = this.getNearbyPoint(point, pointsArray);
            const res = new MapPolygonPoint(0, '', new MapLatLng(pointsArray[index], pointsArray[index + 1]), null);
            res.dataModel = options ? options.dataModel : undefined;
            if (options && options.content) {
              if (this.infoWindowPolyline !== null) {
                this.infoWindowPolyline.close();
              }
              this.infoWindowPolyline = new google.maps.InfoWindow({
                content: options.content,
              });
              this.infoWindowPolyline.setZIndex(999);
              this.infoWindowPolyline.setPosition(res.point);
              this.infoWindowPolyline.open(this.map);
            }
            res.clickPoint = point;
            this.onPolygonClick(res);
          }
        }
      }
    });
    if (result && result.length > 0) {
      const geometry = result[0].getGeometry();
      if (geometry.getType() === 'Point' || geometry.getType() === 'MultiPoint') {
      } else {
        if (geometry.getType() === 'LineString' || geometry.getType() === 'MultiLineString') {
        } else {
          if (geometry.getType() === 'Polygon' || geometry.getType() === 'MultiPolygon') {
            // Calculo el centroide
            let latSW = 90;
            let lngSW = 180;
            let latNE = -90;
            let lngNE = -180;
            geometry.forEachLatLng((pos: any) => {
              latSW = Math.min(latSW, pos.lat());
              lngSW = Math.min(lngSW, pos.lng());
              latNE = Math.max(latNE, pos.lat());
              lngNE = Math.max(lngNE, pos.lng());
            });
            if (options && options.label) {
              // Pongo el texto en el centro
              result.markerText = new google.maps.Marker({
                position: new google.maps.LatLng(latSW + (latNE - latSW) / 2.0, lngSW + (lngNE - lngSW) / 2.0),
                map: this.map,
                icon: ' ',
                label: {
                  color: options?.textColor ? options.textColor : '#000000',
                  // fontWeight: 'bold',
                  text: options.label,
                  fontSize: '18px',
                },
              });
            }
          }
        }
      }
    }
    return result;
  }

  // Borra un GeoJson cargado anteriormente
  override removeGeoJson(obj: any): void {
    if (obj.markerText) {
      obj.markerText.setMap(null);
    }
    obj.forEach((elem: any) => {
      this.map.data.remove(elem);
    });
  }

  // Añade un mapa de calor
  override addHeatMap(id: number, points: MapLatLng[], markers: MapMarker[], radius: number, dissipating: boolean,
    maxIntensity: number, opacity: number, gradient: any[]): HeatMap {
    return new GMapHeatMap(id, this.map, points, markers, radius, dissipating, maxIntensity, opacity, gradient);
  }

  // Elimina un mapa de calor
  override removeHeatMap(heatMap: HeatMap) {
    if (heatMap instanceof GMapHeatMap) {
      heatMap.heatMap.setMap(null);
    }
  }

  // Permite cambiar el puntero del ratón sobre el mapa
  override setMousePointer(pointer: string) {
    this.map.setOptions({
      draggableCursor: 'url(' + pointer + '), default'
    });
  }

  // Devuelve la proyección del mapa
  override getProjection(): any {
    return this.map.getProjection();
  }

  // Pasa una coordenada geográfica a un punto
  override fromLatlngToPoint(position: MapLatLng): MapPoint {
    const pos = new google.maps.LatLng(position.lat, position.lng);
    const point = this.map.getProjection().fromLatLngToPoint(pos);
    return new MapPoint(point.x, point.y);
  }

  // Pasa un punto a corrdenada geográfica
  override fromPointToLatlng(point: MapPoint): MapLatLng {
    const pos = new google.maps.Point(point.x, point.y);
    const position = this.map.getProjection().fromPointToLatLng(pos);
    return new MapLatLng(position.lat(), position.lng());
  }

  override itinerary(fromId: string, toId: string, fromPos: MapLatLng, toPos: MapLatLng, resultId: string): GMapItinerary {
    return new GMapItinerary(this.map, this.ngZone, fromId, toId, fromPos, toPos, resultId, this);
  }

  override latLngToScreenPoint(position: MapLatLng): MapPoint {
    var topRight = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getNorthEast());
    var bottomLeft = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getSouthWest());
    var scale = Math.pow(2, this.map.getZoom());
    var worldPoint = this.map.getProjection().fromLatLngToPoint(new google.maps.LatLng(position.lat, position.lng));
    const p = new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
    return new MapPoint(p.x, p.y);
  }

  override screenPointToLatLng(point: MapPoint): MapLatLng {
    var topRight = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getNorthEast());
    var bottomLeft = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getSouthWest());
    var scale = Math.pow(2, this.map.getZoom());
    var worldPoint = new google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
    const pos = this.map.getProjection().fromPointToLatLng(worldPoint);
    return new MapLatLng(pos.lat(), pos.lng());
  }

  override async loadKml(url: string): Promise<any> {
    if (!url.startsWith('http')) {
      // Recupero el archivo de disco
      const res = await this.http.get(url, { responseType: 'blob' }).toPromise();
      if (res) {
        return new Promise<any>((resolve, reject) => {
          let reader = new FileReader();
          reader.addEventListener("load", async () => {
            const fileBase64: any = reader.result;
            // Me quedo con el contenido del archivo y lo paso a binario
            const xml = atob(fileBase64.split(',')[1]);
            // Creo el DOM con el XML
            const dom = (new DOMParser()).parseFromString(xml, 'text/xml');
            // Creo un geojson
            const k = new KmlToGeoJson();
            const res = k.kml(dom);
            if (res) {
              resolve(this.addGeoJson(res));
            }
          }, false);
          reader.readAsDataURL(res);
        });
      }
    } else {
      // Compruebo si tengo que cambiar el formato de la URL
      // https://drive.google.com/file/d/1u_KH6baHwCRopu4HaArQhazC5B7vmgzB/view?usp=sharing
      // https://drive.google.com/uc?export=download&id=1u_KH6baHwCRopu4HaArQhazC5B7vmgzB
      let urlAux = url;
      if (url.startsWith('https://drive.google.com/file/d/')) {
        urlAux = 'https://drive.google.com/uc?export=download&id=' + url.split('/')[5];
      }
      const res = new google.maps.KmlLayer(
        {
          url: urlAux,
          suppressInfoWindows: false,
          map: this.map,
          zIndex: 99,
          clickable: true,
          preserveViewport: true, // No hacer zoom de encuadre
          screenOverlays: false
        });
      res.addListener("click", (event: any) => {
        // const text = event.featureData.description;
      });
      return res;
    }
  }

  override addKml(xml: string): any {
    // Creo el DOM con el XML
    const dom = (new DOMParser()).parseFromString(xml, 'text/xml');
    // Creo un geojson
    const k = new KmlToGeoJson();
    const res = k.kml(dom);
    if (res) {
      return this.map.addGeoJson(res);
    }
  }

  override removeKml(file: any) {
    if (file) {
      // Compruebo si es una Kml o un GeoJson
      if (file.metadata) {
        file.setMap(null);
      } else {
        this.removeGeoJson(file);
      }
    }
  }

  // Oculta el infowindow de los marcadores
  override closeInfowindowMarker(): void {
    if (this.infoWindowMarker) {
      this.infoWindowMarker.close();
      this.infoWindowMarker = null;
    }
  }

  // Devuelve el punto del polígono más cercano a un punto dado
  public getNearbyPoint(position: any, points: number[]): number {
    let i = 0, index = 0;
    let oldDist = 99999999;
    let lastPoint: MapLatLng | undefined;
    for (i = 0; i < points.length; i += 3) {
      if (lastPoint) {
        const dist = this.distancePointToSegment(lastPoint.lng, lastPoint.lat, points[i + 1],
          points[i], position.lng, position.lat);
        if (dist < oldDist) {
          index = i;
          oldDist = dist;
        }
      }
      lastPoint = new MapLatLng(points[i], points[i + 1]);
    }
    if (index > 0) {
      if (this.dist(position.lng, position.lat, points[index + 1], points[index]) >
        this.dist(position.lng, position.lat, points[index - 2], points[index - 3])) {
        index = index - 3;
      }
    }
    return index;
  }

  override getMaxZoom(): number {
    return this.maxZoom;
  }

}
